// src/hooks/useInactiveCustomers.js
import { useState, useEffect, useCallback, useMemo } from 'react';
import { get } from '../helpers/apiHelper';

export const useInactiveCustomers = (marcaId, useIntelligent = true) => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
        urgency: null,
        segment: null
    });

    const loadCustomers = useCallback(async () => {
        if (!marcaId) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await get(
                `clientes/winback/inactive?useIntelligent=${useIntelligent}`
            );
            setCustomers(response);
        } catch (err) {
            console.error('Error loading customers:', err);
            setError(err.message);
            setCustomers([]);
        } finally {
            setLoading(false);
        }
    }, [marcaId, useIntelligent]);

    const filteredCustomers = useMemo(() => {
        return customers.filter(customer => {
            if (filters.urgency && customer.urgency !== filters.urgency) {
                return false;
            }
            if (filters.segment && customer.segment !== filters.segment) {
                return false;
            }
            return true;
        });
    }, [customers, filters]);

    const filterByUrgency = useCallback((urgency) => {
        setFilters(prev => ({ ...prev, urgency }));
    }, []);

    const filterBySegment = useCallback((segment) => {
        setFilters(prev => ({ ...prev, segment }));
    }, []);

    const clearFilters = useCallback(() => {
        setFilters({ urgency: null, segment: null });
    }, []);

    useEffect(() => {
        loadCustomers();
    }, [loadCustomers]);

    return {
        customers: filteredCustomers,
        allCustomers: customers,
        loading,
        error,
        refresh: loadCustomers,
        filterByUrgency,
        filterBySegment,
        clearFilters,
        filters
    };
};

